import Vue from "vue";
import Vuex from "vuex";
import { getAdminInfo } from "@/api/getData";

Vue.use(Vuex);

const state = {
  adminInfo: {
    avatar: "default.jpg"
  },
  // Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : '',
  token: localStorage.getItem("token") ? localStorage.getItem("token") : "",
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : {},
  menuList: localStorage.getItem("menuList")
    ? JSON.parse(localStorage.getItem("menuList"))
    : {}
};

const mutations = {
  saveAdminInfo(state, adminInfo) {
    state.adminInfo = adminInfo;
  },
  setToken(state, token) {
    state.token = token;
    localStorage.token = token; // 同步存储token至localStorage
  },
  setMenuList(state, menuList) {
    state.menuList = menuList;
    localStorage.menuList = JSON.stringify(menuList);
  },
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.userInfo = JSON.stringify(userInfo);
  }
  // setFakeUserInfo (state, fakeUserInfo) {
  //   state.adminInfo = { avatar: 'fakeAvatar.jpg' } // 设置假的 adminInfo
  //   state.token = 'fakeToken' // 设置假的 token
  //   state.userInfo = fakeUserInfo // 设置假的 userInfo
  //   localStorage.token = 'fakeToken' // 同步存储假的 token 至 localStorage
  //   localStorage.userInfo = JSON.stringify(fakeUserInfo) // 同步存储假的 userInfo 至 localStorage
  // },
};

const actions = {
  async getAdminData({ commit }) {
    try {
      const res = await getAdminInfo();
      if (res.status === 1) {
        commit("saveAdminInfo", res.data);
      } else {
        throw new Error(res.type);
      }
    } catch (err) {
      console.log(err.message);
    }
  }
};

export default new Vuex.Store({
  state,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js